<template>
  <div>
    <div class="top-detail">
      <div class="date-picker">
        <span class="title">表示期間</span>
        <a-month-picker class="w-32"
          v-model="startValue"
          :disabled-date="disabledStartDate"
          format="YYYY年MM月"
          @openChange="handleStartOpenChange"/>
        <span class="self-baseline">&ensp;〜&ensp;</span>
        <a-month-picker class="w-32"
          v-model="endValue"
          :disabled-date="disabledEndDate"
          format="YYYY年MM月"
          :open="endOpen"
          @openChange="handleEndOpenChange"/> 
        <a-select mode="multiple" class="pl-3"
                  placeholder="取引状態"
                   style="width: 50%"
                  @change="handleChange">
           <a-select-option value="1">
             獲得
           </a-select-option>
           <a-select-option value="2">
             利用 
           </a-select-option>
           <a-select-option value="3">
             失効
           </a-select-option>
           <a-select-option value="4">
             取消
           </a-select-option>
        </a-select>
      </div>
      <div class="note">
        <p>
          ※ 過去3年分までの表示となります。<br />
          ※ 表示期間の範囲は1年以内を選択してください。
        </p>
        <button
          v-show="!is_hidden"
          class="ml-4 mr-4 c-btn btn-sm btn-white btn"
        >
          絞り込む
        </button>
      </div>
      <div class="item-pagination">
        <div class="pagination relative">
          <div class="text-bottom w-1/4 sm:w-full flex items-center">
            <strong>{{totalElePointHistory}}</strong>件中
            <span v-if="page === 1 && totalElePointHistory"> 1 </span>
            <span v-if="!totalElePointHistory">0</span>
            <span v-if="page > 1"> {{ (page - 1) * 10 + 1 }}</span>
            ～
            <span v-if="totalElePointHistory <= 10"> {{ totalElePointHistory }} </span>
            <span v-if="totalElePointHistory > 10 && ((page - 1) * 10 < Math.floor(totalElePointHistory/10)*10) "> {{ page * 10 }}</span>
            <span v-if="totalElePointHistory > 10 && ((page - 1) * 10 >= Math.floor(totalElePointHistory/10)*10 && (page - 1) * 10 < totalElePointHistory) "> {{ (page -1) * 10 + totalElePointHistory % 10}}</span>
            件表示
          </div>
          <Pagination
            class="sm:w-full flex sm:hidden mx-auto absolute justify-center inset-0 m-auto"
            :page="page"
            :pageCount="5"
            :pageSlot="5"
            :default-current="1"
            @onChange="onChange"
            :totalRecord="totalElePointHistory"
          />
        </div>
      </div>
    </div>
    <a-divider />
    <div class="content-detail">
      <!-- ITEM- CONTENT1 -->
      <div v-for="(item, index) in listDataHistory" :key="index">
        <article class="pt-2">
          <div class="date">
            <div v-if="item.commandType === 2 || item.commandType === 3" class="date-item sub">
              <span>{{ item.date }}</span>
              <p>{{ item.statusText }}</p>
            </div>
            <div v-else class="date-item plus">
              <span v-if="item.date">{{ item.date }}</span>
              <p>{{ item.statusText }}</p>
            </div>
            <div class="item-content">
              <span class="two-lines-ellipsis f-14"> {{ item.content }}</span>
            </div>
          </div>
          <div v-if="item.commandType === 1" class="span blue">
            <span>+{{ item.point | formatInteger}}P</span>
          </div>
          <div v-if="item.commandType === 2 || item.commandType === 3 || item.commandType === 4" class="span red">
            <span>-{{ item.point | formatInteger }}P</span>
          </div>
        </article>
        
        <a-divider v-if="index < listDataHistory.length - 1" class="divider" />
      </div>
      <div v-if="listDataHistory.length <= 0" class="pb-5">
      <a-list :data-source="[]" />
      <div class="text-center"> 
        <span class="text-blank">{{ descriptionImageBlank }}</span>
      </div>
    </div>  
    </div>
    <a-divider />
    <div class="item-pagination hidden sm:block ml-4">
      <div class="pagination relative">
        <div class="text-bottom w-1/4 sm:w-full flex items-center">
          <strong>{{totalElePointHistory}}</strong>件中
          <span v-if="page === 1 && totalElePointHistory"> 1 </span>
          <span v-if="!totalElePointHistory">0</span>
          <span v-if="page > 1"> {{ (page - 1) * 10 + 1 }}</span>
          ～
          <span v-if="totalElePointHistory <= 10"> {{ totalElePointHistory }} </span>
          <span v-if="totalElePointHistory > 10 && ((page - 1) * 10 < Math.floor(totalElePointHistory/10)*10) "> {{ page * 10 }}</span>
          <span v-if="totalElePointHistory > 10 && ((page - 1) * 10 >= Math.floor(totalElePointHistory/10)*10 && (page - 1) * 10 < totalElePointHistory) "> {{ (page -1) * 10 + totalElePointHistory % 10}}</span>
          件表示
        </div>
        <Pagination
          class="sm:w-full flex justify-center absolute"
          :page="page"
          :pageCount="5"
          :pageSlot="5"
          :default-current="1"
          @onChange="onChange"
          :totalRecord="totalElePointHistory"
        />
      </div>
    </div>
    <a-divider class="hidden sm:block" />
  </div>
</template>

<script>
import { Pagination } from '@/components/primitive'
import moment from 'moment'

export default {
  components: {
    Pagination
  },

  props: {
    listDataHistory: {
      type: Array
    },
    totalElePointHistory: {
      type: Number
    }
  },

  data() {
    return {
      initLoad: true,
      startValue: null,
      endValue: null,
      endOpen: false,
      pointFrom: '',
      pointTo: '',
      page: 1,
      is_hidden: true,
      windowHeight: null,
      statusNum: null,
      descriptionImageBlank: '誠に申し訳ございませんが、データがありませんでした',
      value: [],
      dateBegin: null,
      dateEnd: null
    }
  },

  mounted() {
    this.startValue = moment(moment().subtract(2, 'months'), 'YYYY/MM/DD')
    this.endValue = moment(moment().clone().endOf('month'), 'YYYY/MM/DD')
    window.addEventListener('resize', () => {
      this.windowHeight = window.innerWidth
    })
    this.getDefaultDateValue()
  },
  watch: {
    windowHeight() {
      if (this.windowHeight > 768) {
        this.is_hidden = true
      } else {
        this.is_hidden = false
      }
    },
    startValue(val) {
      if(!this.initLoad || !val) {
        const startTm = val ? val : ''
        if(startTm) {
          this.pointFrom = startTm.format('YYYYMM01T000000+0900')
        }
        if(!startTm) {
          this.pointFrom = ''
        }
        this.handleChange(this.statusNum)
      }
    },
    endValue(val) {
      if(!this.initLoad || !val) {
        const endTm = val ? val : ''
        if(endTm) {
          this.pointTo = endTm.clone().endOf('month').format('YYYYMMDDT235959+0900')
        }
        if(!endTm) {
          this.pointTo = ''
        }
        this.handleChange(this.statusNum)
      }
    }
  },
  methods: {
    disabledStartDate(startValue) {
      const endValue = this.endValue
      if (!startValue || !endValue) {
        return false
      }
      return startValue.valueOf() > endValue.valueOf()
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange(open) {
      this.initLoad = false
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.initLoad = false
      this.endOpen = open
    },
    moment,
    getDefaultDateValue() {
      this.dateEnd = moment().clone().endOf('month').format('YYYYMMDDT235959+0900')
      const datePast = moment().subtract(2, 'months')
      this.dateBegin = datePast.format('YYYYMM01T000000+0900')
      this.pointFrom = this.dateBegin
      this.pointTo = this.dateEnd
      this.handleChange(0)
    },
    getListPoint() {
      const objDateStr = {
        pointFrom: this.pointFrom,
        pointTo: this.pointTo
      }
      this.$emit('getListPoint', objDateStr)
    },

    handleChange(value) {
      this.statusNum = value
      const params = {
        startIndex: this.page,
        count: 10,
        pointFrom: this.pointFrom,
        pointTo: this.pointTo,
        commandType: (value && value.length !== 0) ? value : ['1', '2', '3', '4']
      }
      this.$emit('getListPoint', params)
    },
    onChange(page) {
      this.page = page
      this.handleChange(this.statusNum)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
